import { pUiVersionKontrol, rUiVersionKontrolSonuc, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';

export const action_api_set_input = (
    body: pUiVersionKontrol | null | undefined
): IInputAction<pUiVersionKontrol> =>
    ActionFunctions.action_api_set_input(ActionSubTypes.API_UIVERSIONKONTROL, true, body);

export const action_async_start = (body: pUiVersionKontrol): IPromiseAction<pUiVersionKontrol> =>
    ActionFunctions.action_async_start_promise(
        ActionSubTypes.API_UIVERSIONKONTROL,
        new Api.User.UiVersionKontrol().Request(body),
        false,
        false,
        body
    );

export const action_async_complete = (
    data: rValue<rUiVersionKontrolSonuc> | null | undefined,
    error: IError | null | undefined
): IApiAction<rUiVersionKontrolSonuc> =>
    ActionFunctions.action_async_complete_api<rUiVersionKontrolSonuc>(
        ActionSubTypes.API_UIVERSIONKONTROL,
        data?.Value,
        error
    );
